// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"406923e6","186":"ff490c7a","225":"f51b2544","344":"4b7deaa2","372":"76969812","377":"8597bee9","738":"522db493","841":"2d9c9559","856":"f71b6412"}[chunkId] + ".chunk.js";
};